/** Product releases use x.y.z; CI's -build.N suffix is not a newer release. */
export function parseProductVersion(value: unknown): number[] | null {
  if (typeof value !== 'string') return null;
  const match = value.trim().match(/^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-build\.(?:0|[1-9]\d*))?(?:\+[\da-zA-Z-]+(?:\.[\da-zA-Z-]+)*)?$/);
  if (!match) return null;
  const parts = match.slice(1, 4).map(Number);
  return parts.every(Number.isSafeInteger) ? parts : null;
}

export function isNewerProductVersion(candidate: unknown, installed: unknown): boolean {
  const candidateParts = parseProductVersion(candidate);
  const installedParts = parseProductVersion(installed);
  if (!candidateParts || !installedParts) return false;
  for (let index = 0; index < candidateParts.length; index += 1) {
    if (candidateParts[index] !== installedParts[index]) return candidateParts[index] > installedParts[index];
  }
  return false;
}
